import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { BrowserUtility } from './../utility/browser.utility';
@Injectable()
export class HttpAuthInterceptor implements HttpInterceptor {
constructor() {}
browserUtil: BrowserUtility = new BrowserUtility();
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const token = this.browserUtil.getFromSessionStorage('token');
    let changedRequest = request;
    const headerSettings: { [name: string]: string | string[]; } = {};

    for (const key of request.headers.keys()) {
      headerSettings[key] = request.headers.getAll(key);
    }

    if (token) {
      changedRequest = request.clone({
        headers: request.headers.set(
          'Authorization',
          'Bearer ' + token
        )
      });
    }
    return next.handle(changedRequest);
  }
}

